{
  "name": "@ic-monorepo/source",
  "version": "68fbc3855ba60d9fef994988a3d63fe62f6c9f53",
  "license": "UNLICENSED",
  "packageManager": "pnpm@11.5.3",
  "scripts": {
    "start": "nx serve",
    "serve-portal": "export NODE_OPTIONS=--max_old_space_size=8192 && nx run portal:serve:development  --disable-host-check",
    "serve-portal:sandbox": "export NODE_OPTIONS=--max_old_space_size=8192 && node scripts/serve-portal-sandbox.mjs",
    "test-affected": "TZ=GB NODE_OPTIONS='--max_old_space_size=4096' nx affected -t test --coverage --coverageReporters=lcov --base=origin/develop --head=HEAD --parallel=3",
    "test-portal-affected": "TZ=GB NODE_OPTIONS='--max_old_space_size=4096' nx affected -t test --coverage --coverageReporters=lcov --exclude=libs/** --base=origin/develop --head=HEAD --parallel=3",
    "test-libs-affected": "TZ=GB NODE_OPTIONS='--max_old_space_size=4096' nx affected -t test --coverage --coverageReporters=lcov --exclude=apps/** --base=origin/develop --head=HEAD --parallel=3",
    "test-all-frontend": "TZ=GB NODE_OPTIONS='--max_old_space_size=8192' nx affected --target=test --configuration=ci --parallel=4 --exclude='functions' --coverage --coverageReporters=lcov --logHeapUsage",
    "test-scripts": "node --test scripts/sandbox/*.test.mjs scripts/lint/*.test.mjs tools/eslint-rules/*.test.js && bash .claude/hooks/read-only-bash.test.sh",
    "lint:suppress": "nx run-many -t lint --all --exclude=agents --skip-nx-cache --output-style=stream",
    "lint:prune": "nx run-many -t lint --all --exclude=agents --skip-nx-cache --output-style=stream --prune-suppressions",
    "test-coverage-merge": "node scripts/test-coverage-merge.js",
    "test-portal": "TZ=GB NODE_OPTIONS='--max_old_space_size=4096' nx run portal:test --configuration=ci",
    "build-portal": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build",
    "build-portal:stats": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build --stats-json",
    "build-portal:production": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build:production",
    "build-portal:preview": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build:preview && node scripts/sandbox/build-preview-config.mjs portal",
    "build-portal:staging": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build:staging && node -e \"require('fs').copyFileSync('apps/frontend/portal/src/configs/staging.json','dist/apps/frontend/portal/browser/config.json')\"",
    "build-portal:usa": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build:production && node -e \"require('fs').copyFileSync('apps/frontend/portal/src/configs/usa.json','dist/apps/frontend/portal/browser/config.json')\"",
    "build-portal:europe": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build:production && node -e \"require('fs').copyFileSync('apps/frontend/portal/src/configs/europe.json','dist/apps/frontend/portal/browser/config.json')\"",
    "build-portal:uk": "NODE_OPTIONS='--max_old_space_size=4096' nx run portal:build:production && node -e \"require('fs').copyFileSync('apps/frontend/portal/src/configs/uk.json','dist/apps/frontend/portal/browser/config.json')\"",
    "build-patient-app": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build",
    "build-patient-app:production": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:production",
    "build-patient-app:preview": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:preview && node scripts/sandbox/build-preview-config.mjs patient-submissions",
    "build-patient-app:development": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:development",
    "build-patient-app:staging": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:staging && node -e \"require('fs').copyFileSync('apps/patient-submissions/src/configs/staging.json','dist/apps/patient-submissions/browser/config.json')\"",
    "build-patient-app:usa": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:production && node -e \"require('fs').copyFileSync('apps/patient-submissions/src/configs/usa.json','dist/apps/patient-submissions/browser/config.json')\"",
    "build-patient-app:europe": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:production && node -e \"require('fs').copyFileSync('apps/patient-submissions/src/configs/europe.json','dist/apps/patient-submissions/browser/config.json')\"",
    "build-patient-app:uk": "NODE_OPTIONS='--max_old_space_size=4096' nx run patient-submissions:build:production && node -e \"require('fs').copyFileSync('apps/patient-submissions/src/configs/uk.json','dist/apps/patient-submissions/browser/config.json')\"",
    "prepare": "husky install",
    "portal:stats": "npx webpack-bundle-analyzer dist/apps/frontend/portal/stats.json",
    "ic-types": "sh ./scripts/install-ic-types.sh",
    "script:add-created-maps": "npx ts-node scripts/node/add-missing-created-maps.ts",
    "script:add-created-maps:dry-run": "npx ts-node scripts/node/add-missing-created-maps.ts --dry-run",
    "sync:primitive-tokens": "nx generate @ic-monorepo/isla:sync-primitive-tokens tokens.json light",
    "docs:serve": "cd docs && python3 -m mkdocs serve",
    "docs:build": "bash docs/build-docs-with-auth.sh",
    "docs:deploy": "bash docs/build-docs-with-auth.sh && firebase deploy --only hosting:docs --project portal-dev-e4b9a",
    "deploy:dev": "firebase deploy --config firebase.dev.json --project portal-dev-e4b9a",
    "analyze:ngcompass": "ngcompass analyze",
    "analyze:ngcompass:ci": "ngcompass analyze --profile ci",
    "analyze:ngcompass:circular": "ngcompass circular",
    "analyze:dead-code": "node scripts/dead-code/detect-dead-code.mjs",
    "test:rules": "firebase emulators:exec --only firestore \"jest --config firebase/rules-tests/jest.config.js\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.0.8",
    "@angular/cdk": "22.0.6",
    "@angular/common": "22.0.8",
    "@angular/compiler": "22.0.8",
    "@angular/core": "22.0.8",
    "@angular/fire": "20.0.1",
    "@angular/forms": "22.0.8",
    "@angular/platform-browser": "22.0.8",
    "@angular/platform-browser-dynamic": "22.0.8",
    "@angular/pwa": "22.0.8",
    "@angular/router": "22.0.8",
    "@angular/service-worker": "22.0.8",
    "@apollo/client": "^3.0.0",
    "@firebase/firestore": "4.16.0",
    "@firebase/firestore-types": "^3.0.0",
    "@google-cloud/firestore": "^7.1.0",
    "@google-cloud/pubsub": "^4.0.6",
    "@google-cloud/secret-manager": "^5.0.0",
    "@google-cloud/storage": "^5.8.5",
    "@intercom/messenger-js-sdk": "^0.0.14",
    "@islacare/ic-types": "1.947.0",
    "@meddv/ngx-pinch-zoom": "20.0.0",
    "@ngneat/spectator": "^21.0.1",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/component-store": "^20.0.0",
    "@ngrx/operators": "20.0.0",
    "@ngrx/signals": "20.0.0",
    "@ngx-formly/core": "^7.0.0",
    "@primeuix/themes": "^1.2.5",
    "@sentry/angular": "^10.69.0",
    "@sentry/tracing": "^7.120.3",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/container-queries": "^0.1.1",
    "@tailwindcss/typography": "^0.5.10",
    "@types/d3-drag": "^3.0.7",
    "@types/d3-selection": "^3.0.11",
    "@types/d3-zoom": "^3.0.8",
    "@videogular/ngx-videogular": "^8.0.0",
    "ag-charts-angular": "^12.2.0",
    "ag-charts-community": "12.3.1",
    "angular-code-input": "^2.0.0",
    "angular-gridster2": "^21.0.0",
    "apollo-angular": "^11.0.0",
    "backoff-rxjs": "^7.0.0",
    "chart.js": "^4.4.4",
    "chartjs-adapter-date-fns": "^3.0.0",
    "chartjs-chart-sankey": "^0.19.1",
    "core-js": "^3.45.1",
    "cropperjs": "^1.6.1",
    "d3-drag": "^3.0.0",
    "d3-selection": "^3.0.0",
    "d3-zoom": "^3.0.0",
    "date-fns": "^2.30.0",
    "date-fns-tz": "^2.0.0",
    "dexie": "^4.0.4",
    "export-to-csv": "^1.2.2",
    "file-saver": "^2.0.5",
    "firebase": "12.16.0",
    "firebase-admin": "^12.0.0",
    "firestore-jest-mock": "^0.17.0",
    "heic2any": "0.0.4",
    "intl-tel-input": "^17.0.21",
    "libphonenumber-js": "^1.13.6",
    "lodash": "^4.17.21",
    "lodash-es": "^4.18.1",
    "markerjs2": "^2.31.1",
    "mediainfo.js": "^0.2.1",
    "msw": "^2.0.0",
    "nanoid": "3.3.11",
    "ng-mocks": "^14.15.3",
    "ng-qrcode": "^20.0.0",
    "ng2-charts": "^5.0.3",
    "ngx-drag-drop": "^20.0.1",
    "ngx-image-cropper": "^9.1.5",
    "ngx-vflow": "^2.5.0",
    "ngx-webcam": "^0.4.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "recordrtc": "^5.6.2",
    "rtf.js": "^3.0.9",
    "rxjs": "~7.8.0",
    "sharp": "0.34.1",
    "tailwindcss-animated": "^1.0.1",
    "tailwindcss-primeui": "^0.6.1",
    "ts-cacheable": "^1.0.10",
    "tslib": "^2.8.1",
    "uuid": "^8.3.2",
    "zod": "^3.22.4",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-architects/ngrx-toolkit": "^20.6.0",
    "@angular-devkit/build-angular": "22.0.8",
    "@angular-devkit/core": "22.0.8",
    "@angular-devkit/schematics": "22.0.8",
    "@angular-eslint/eslint-plugin": "22.1.0",
    "@angular-eslint/eslint-plugin-template": "22.1.0",
    "@angular-eslint/template-parser": "22.1.0",
    "@angular/build": "22.0.8",
    "@angular/cli": "22.0.8",
    "@angular/compiler-cli": "22.0.8",
    "@angular/language-service": "22.0.8",
    "@eslint/eslintrc": "^2.1.1",
    "@eslint/js": "^9",
    "@eslint/markdown": "^8.0.3",
    "@firebase/rules-unit-testing": "^5.0.2",
    "@nx/angular": "23.1.0",
    "@nx/devkit": "23.1.0",
    "@nx/esbuild": "23.1.0",
    "@nx/eslint": "23.1.0",
    "@nx/eslint-plugin": "23.1.0",
    "@nx/jest": "23.1.0",
    "@nx/js": "23.1.0",
    "@nx/node": "23.1.0",
    "@nx/plugin": "23.1.0",
    "@nx/web": "23.1.0",
    "@nx/workspace": "23.1.0",
    "@schematics/angular": "22.0.8",
    "@simondotm/nx-firebase": "^2.1.2",
    "@swc-node/register": "1.11.1",
    "@swc/cli": "0.8.1",
    "@swc/core": "1.15.5",
    "@swc/helpers": "0.5.18",
    "@tsconfig/node20": "^20.1.4",
    "@types/form-data": "^2.5.2",
    "@types/intl-tel-input": "^17.0.6",
    "@types/jest": "30.0.0",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^24.7.2",
    "@types/sharp": "^0.28.3",
    "@typescript-eslint/utils": "^8",
    "angular-eslint": "22.1.0",
    "autoprefixer": "^10.4.21",
    "babel-jest": "30.3.0",
    "csv-parser": "^3.2.0",
    "eslint": "^9.8.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-import-resolver-typescript": "^3.5.2",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jest": "^29",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-rxjs-x": "^0.9.5",
    "eslint-plugin-tailwindcss": "^3.18.3",
    "firebase-tools": "^14.12.1",
    "firestore-jest-mock": "^0.17.0",
    "husky": "^8.0.3",
    "jest": "30.3.0",
    "jest-environment-jsdom": "30.0.0",
    "jest-environment-node": "^29.4.1",
    "jest-marbles": "^3.1.0",
    "jest-preset-angular": "17.0.0",
    "jest-util": "30.0.0",
    "jsonc-eslint-parser": "^2.1.0",
    "kill-port": "^2.0.1",
    "knip": "6.27.0",
    "lint-staged": "^16.0.0",
    "ngcompass": "0.2.2-beta",
    "nx": "23.1.0",
    "postcss": "^8.4.5",
    "prettier": "^3.1.0",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "tailwindcss": "^3.0.2",
    "testcontainers": "^10.2.2",
    "timezone-mock": "^1.3.6",
    "ts-jest": "29.4.12",
    "ts-node": "10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.29.0"
  },
  "optionalDependencies": {
    "canvas": "^3.2.3"
  }
}
